import { fail, ok, type Result } from './result.js';
import { normalizarTexto } from './vo/texto.js';

/**
 * Lista B de 30/10 (item 13): cancelar e excluir tarefa do CRM pedem a justificativa. A tela e a API usam esta mesma regra
 * (sem `trim` solto): NFC, sem invisíveis nem espaço nas bordas, mínimo e máximo de caracteres.
 */
export const JUSTIFICATIVA_MINIMO = 10;
export const JUSTIFICATIVA_MAXIMO = 500;

export function validarJustificativa(bruto: unknown): Result<string> {
  const j = typeof bruto === 'string' ? normalizarTexto(bruto) : '';
  if (Array.from(j).length < JUSTIFICATIVA_MINIMO) {
    return fail('justificativa.obrigatoria', `Escreva a justificativa (no mínimo ${JUSTIFICATIVA_MINIMO} caracteres)`, { campo: 'justificativa' });
  }
  if (Array.from(j).length > JUSTIFICATIVA_MAXIMO) {
    return fail('justificativa.longa', `A justificativa tem no máximo ${JUSTIFICATIVA_MAXIMO} caracteres`, { campo: 'justificativa' });
  }
  return ok(j);
}
